module.exports = __webpack_public_path__ + "img/f_3.5800ebb9.png";